import {
  UserAllListSuccess,
  UserListSuccess,
  UserAddedSuccess,
  ClearUserData,
} from '../../actionTypes/userActions';

const inititalState = {
  allUsers: [],
  userList: [],
};

export const userReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UserAllListSuccess:
      return {
        ...state,
        allUsers: payload,
      };
    case UserListSuccess:
      return {
        ...state,
        userList: payload,
      };
    case UserAddedSuccess:
      return {
        ...state,
        allUsers: [...state.users, payload],
      };
    case ClearUserData:
      return {
        ...state,
        allUsers: [],
      };
    default:
      return state;
  }
};
